export const LOCAL_STORAGE_KEYS = {
  TELEGRAM_ID: "TELEGRAM_ID",
};
